import { groupedItemIdsKey } from "utils/groupedItemIdsKey";

/** Canonical identity for an API-provided group of concrete trade items. */
export function tradeItemGroupKey(ids: readonly string[]): string {
  return groupedItemIdsKey(ids);
}
